export default function TradeIcon({
    style,
    fill = "#676767",
}) {
    return <svg style={style} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15Z" stroke={fill} strokeWidth="0.7" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M2.93066 8.54431H4.72295L6.16458 6.41677L8.11272 11.136L10.0219 5.10156L11.1908 8.54431H12.8272" stroke={fill} strokeWidth="0.7" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
}